import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { NgxCourseService } from './course.service';

export const ngxCourseServiceModule = angular.module('ngxCourseServiceModule', [])
	.factory('ngxCourseService', downgradeInjectable(NgxCourseService) as any)
	.name;
